module.exports = __webpack_public_path__ + "img/LV40203178596.f984d62f.png";